import { addYears, getYear, subMonths } from 'date-fns';

/**
 * Model to hold a single grade.
 * Example: Pre-Kindergarten, Kindergarten, 1st, 2nd, etc
 */
export class Grade {
    public static ID_NA: string = '7a7e1f7f-b6b1-49f1-95c7-34a93d689875';

    public id: string;
    public name: string;
    public sequence: number;
    public numericValue: number;
    public highSchoolGradYear: number;

    public calculateHighSchoolGradeYear(): number {
        if (this.id === Grade.ID_NA ||
            this.numericValue > 12) {
            return null;
        }

        const numberOfYearsTilGraduation: number = 13 - this.numericValue;
        return getYear(subMonths(addYears(new Date(), numberOfYearsTilGraduation), 7));
    }

    public clone(): Grade {
        const clone: Grade = new Grade();
        clone.id = this.id;
        clone.name = this.name;
        clone.sequence = this.sequence;
        clone.numericValue = this.numericValue;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'grade';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.sequence = this.sequence;
        json.data.attributes.numericValue = this.numericValue;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): Grade {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.sequence = attrs['sequence'];
        this.numericValue = attrs['numericValue'];
        this.highSchoolGradYear = this.calculateHighSchoolGradeYear();

        return this;
    }
}
